export default __webpack_public_path__ + "static/media/static_img_tum-logo-white-xs.4ad53c4d.svg";